import { Outlet } from "react-router-dom";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import ScrollButton from "../../ScrollButton/ScrollButton";

const Layout = () => {
  return (
    <>
    <ScrollButton />
      <Header></Header>
      <main>
        <Outlet />
      </main>
      <Footer></Footer>
    </>
  );
};

export default Layout;
